/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Data API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation } from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  CurrentV7RequestArrayBody,
  DataClusterRequest,
  DataClusterResponse,
  DataCurrentResponse,
  DataHeatmapListResponse,
  DataHeatmapResponse,
  DataMetaStatResponse,
  DataMetricResponse,
  DataScatterDetailResponse,
  DataScatterResponse,
  DataScatterTableResponse,
  DataTableResponse,
  DataTopologyResponse,
  DatabaseServiceMetricV7Request,
  ElasticSearchProcessRequestArrayBody,
  HeatmapListV7Request,
  HeatmapV7Request,
  MetaStatV7Request,
  MetricV7RequestArrayBody,
  ScatterDetailRequestArrayBody,
  ScatterV7Request,
  ServiceDataMetricResponse,
  TableV7Request,
  TopologyV7Request,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Cluster Response
 */
export const postV7DataCluster = (
  dataClusterRequest: MaybeRef<DataClusterRequest[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dataClusterRequest = unref(dataClusterRequest);

  return customAxiosInstance<DataClusterResponse>(
    {
      url: `/api/v7/data/cluster`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dataClusterRequest,
      signal,
    },
    options,
  );
};

export const getPostV7DataClusterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataCluster>>,
    TError,
    { data: BodyType<DataClusterRequest[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataCluster>>,
  TError,
  { data: BodyType<DataClusterRequest[]> },
  TContext
> => {
  const mutationKey = ['postV7DataCluster'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataCluster>>,
    { data: BodyType<DataClusterRequest[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataCluster(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataClusterMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataCluster>>
>;
export type PostV7DataClusterMutationBody = BodyType<DataClusterRequest[]>;
export type PostV7DataClusterMutationError = ErrorType<unknown>;

/**
 * @summary Cluster Response
 */
export const usePostV7DataCluster = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataCluster>>,
      TError,
      { data: BodyType<DataClusterRequest[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataCluster>>,
  TError,
  { data: BodyType<DataClusterRequest[]> },
  TContext
> => {
  const mutationOptions = getPostV7DataClusterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Current Response
 */
export const postV7DataCurrent = (
  currentV7RequestArrayBody: MaybeRef<CurrentV7RequestArrayBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  currentV7RequestArrayBody = unref(currentV7RequestArrayBody);

  return customAxiosInstance<DataCurrentResponse>(
    {
      url: `/api/v7/data/current`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: currentV7RequestArrayBody,
      signal,
    },
    options,
  );
};

export const getPostV7DataCurrentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataCurrent>>,
    TError,
    { data: BodyType<CurrentV7RequestArrayBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataCurrent>>,
  TError,
  { data: BodyType<CurrentV7RequestArrayBody> },
  TContext
> => {
  const mutationKey = ['postV7DataCurrent'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataCurrent>>,
    { data: BodyType<CurrentV7RequestArrayBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataCurrent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataCurrentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataCurrent>>
>;
export type PostV7DataCurrentMutationBody = BodyType<CurrentV7RequestArrayBody>;
export type PostV7DataCurrentMutationError = ErrorType<unknown>;

/**
 * @summary Current Response
 */
export const usePostV7DataCurrent = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataCurrent>>,
      TError,
      { data: BodyType<CurrentV7RequestArrayBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataCurrent>>,
  TError,
  { data: BodyType<CurrentV7RequestArrayBody> },
  TContext
> => {
  const mutationOptions = getPostV7DataCurrentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Current List Response
 */
export const postV7DataCurrentList = (
  currentV7RequestArrayBody: MaybeRef<CurrentV7RequestArrayBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  currentV7RequestArrayBody = unref(currentV7RequestArrayBody);

  return customAxiosInstance<DataTableResponse>(
    {
      url: `/api/v7/data/current-list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: currentV7RequestArrayBody,
      signal,
    },
    options,
  );
};

export const getPostV7DataCurrentListMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataCurrentList>>,
    TError,
    { data: BodyType<CurrentV7RequestArrayBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataCurrentList>>,
  TError,
  { data: BodyType<CurrentV7RequestArrayBody> },
  TContext
> => {
  const mutationKey = ['postV7DataCurrentList'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataCurrentList>>,
    { data: BodyType<CurrentV7RequestArrayBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataCurrentList(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataCurrentListMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataCurrentList>>
>;
export type PostV7DataCurrentListMutationBody = BodyType<CurrentV7RequestArrayBody>;
export type PostV7DataCurrentListMutationError = ErrorType<unknown>;

/**
 * @summary Current List Response
 */
export const usePostV7DataCurrentList = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataCurrentList>>,
      TError,
      { data: BodyType<CurrentV7RequestArrayBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataCurrentList>>,
  TError,
  { data: BodyType<CurrentV7RequestArrayBody> },
  TContext
> => {
  const mutationOptions = getPostV7DataCurrentListMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getElasticSearchCurrent
 */
export const postV7DataElasticsearchCurrent = (
  elasticSearchProcessRequestArrayBody: MaybeRef<ElasticSearchProcessRequestArrayBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  elasticSearchProcessRequestArrayBody = unref(elasticSearchProcessRequestArrayBody);

  return customAxiosInstance<DataCurrentResponse>(
    {
      url: `/api/v7/data/elasticsearch-current`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: elasticSearchProcessRequestArrayBody,
      signal,
    },
    options,
  );
};

export const getPostV7DataElasticsearchCurrentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataElasticsearchCurrent>>,
    TError,
    { data: BodyType<ElasticSearchProcessRequestArrayBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataElasticsearchCurrent>>,
  TError,
  { data: BodyType<ElasticSearchProcessRequestArrayBody> },
  TContext
> => {
  const mutationKey = ['postV7DataElasticsearchCurrent'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataElasticsearchCurrent>>,
    { data: BodyType<ElasticSearchProcessRequestArrayBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataElasticsearchCurrent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataElasticsearchCurrentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataElasticsearchCurrent>>
>;
export type PostV7DataElasticsearchCurrentMutationBody =
  BodyType<ElasticSearchProcessRequestArrayBody>;
export type PostV7DataElasticsearchCurrentMutationError = ErrorType<unknown>;

/**
 * @summary getElasticSearchCurrent
 */
export const usePostV7DataElasticsearchCurrent = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataElasticsearchCurrent>>,
      TError,
      { data: BodyType<ElasticSearchProcessRequestArrayBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataElasticsearchCurrent>>,
  TError,
  { data: BodyType<ElasticSearchProcessRequestArrayBody> },
  TContext
> => {
  const mutationOptions = getPostV7DataElasticsearchCurrentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getElasticSearchMetrics
 */
export const postV7DataElasticsearchMetrics = (
  elasticSearchProcessRequestArrayBody: MaybeRef<ElasticSearchProcessRequestArrayBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  elasticSearchProcessRequestArrayBody = unref(elasticSearchProcessRequestArrayBody);

  return customAxiosInstance<DataMetricResponse>(
    {
      url: `/api/v7/data/elasticsearch-metrics`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: elasticSearchProcessRequestArrayBody,
      signal,
    },
    options,
  );
};

export const getPostV7DataElasticsearchMetricsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataElasticsearchMetrics>>,
    TError,
    { data: BodyType<ElasticSearchProcessRequestArrayBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataElasticsearchMetrics>>,
  TError,
  { data: BodyType<ElasticSearchProcessRequestArrayBody> },
  TContext
> => {
  const mutationKey = ['postV7DataElasticsearchMetrics'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataElasticsearchMetrics>>,
    { data: BodyType<ElasticSearchProcessRequestArrayBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataElasticsearchMetrics(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataElasticsearchMetricsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataElasticsearchMetrics>>
>;
export type PostV7DataElasticsearchMetricsMutationBody =
  BodyType<ElasticSearchProcessRequestArrayBody>;
export type PostV7DataElasticsearchMetricsMutationError = ErrorType<unknown>;

/**
 * @summary getElasticSearchMetrics
 */
export const usePostV7DataElasticsearchMetrics = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataElasticsearchMetrics>>,
      TError,
      { data: BodyType<ElasticSearchProcessRequestArrayBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataElasticsearchMetrics>>,
  TError,
  { data: BodyType<ElasticSearchProcessRequestArrayBody> },
  TContext
> => {
  const mutationOptions = getPostV7DataElasticsearchMetricsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getElasticSearchTable
 */
export const postV7DataElasticsearchTable = (
  elasticSearchProcessRequestArrayBody: MaybeRef<ElasticSearchProcessRequestArrayBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  elasticSearchProcessRequestArrayBody = unref(elasticSearchProcessRequestArrayBody);

  return customAxiosInstance<DataTableResponse>(
    {
      url: `/api/v7/data/elasticsearch-table`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: elasticSearchProcessRequestArrayBody,
      signal,
    },
    options,
  );
};

export const getPostV7DataElasticsearchTableMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataElasticsearchTable>>,
    TError,
    { data: BodyType<ElasticSearchProcessRequestArrayBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataElasticsearchTable>>,
  TError,
  { data: BodyType<ElasticSearchProcessRequestArrayBody> },
  TContext
> => {
  const mutationKey = ['postV7DataElasticsearchTable'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataElasticsearchTable>>,
    { data: BodyType<ElasticSearchProcessRequestArrayBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataElasticsearchTable(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataElasticsearchTableMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataElasticsearchTable>>
>;
export type PostV7DataElasticsearchTableMutationBody =
  BodyType<ElasticSearchProcessRequestArrayBody>;
export type PostV7DataElasticsearchTableMutationError = ErrorType<unknown>;

/**
 * @summary getElasticSearchTable
 */
export const usePostV7DataElasticsearchTable = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataElasticsearchTable>>,
      TError,
      { data: BodyType<ElasticSearchProcessRequestArrayBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataElasticsearchTable>>,
  TError,
  { data: BodyType<ElasticSearchProcessRequestArrayBody> },
  TContext
> => {
  const mutationOptions = getPostV7DataElasticsearchTableMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary heatmap Response
 */
export const postV7DataHeatmap = (
  heatmapV7Request: MaybeRef<HeatmapV7Request[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  heatmapV7Request = unref(heatmapV7Request);

  return customAxiosInstance<DataHeatmapResponse>(
    {
      url: `/api/v7/data/heatmap`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: heatmapV7Request,
      signal,
    },
    options,
  );
};

export const getPostV7DataHeatmapMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataHeatmap>>,
    TError,
    { data: BodyType<HeatmapV7Request[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataHeatmap>>,
  TError,
  { data: BodyType<HeatmapV7Request[]> },
  TContext
> => {
  const mutationKey = ['postV7DataHeatmap'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataHeatmap>>,
    { data: BodyType<HeatmapV7Request[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataHeatmap(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataHeatmapMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataHeatmap>>
>;
export type PostV7DataHeatmapMutationBody = BodyType<HeatmapV7Request[]>;
export type PostV7DataHeatmapMutationError = ErrorType<unknown>;

/**
 * @summary heatmap Response
 */
export const usePostV7DataHeatmap = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataHeatmap>>,
      TError,
      { data: BodyType<HeatmapV7Request[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataHeatmap>>,
  TError,
  { data: BodyType<HeatmapV7Request[]> },
  TContext
> => {
  const mutationOptions = getPostV7DataHeatmapMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary heatmap-list response
 */
export const postV7DataHeatmapList = (
  heatmapListV7Request: MaybeRef<HeatmapListV7Request[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  heatmapListV7Request = unref(heatmapListV7Request);

  return customAxiosInstance<DataHeatmapListResponse>(
    {
      url: `/api/v7/data/heatmap-list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: heatmapListV7Request,
      signal,
    },
    options,
  );
};

export const getPostV7DataHeatmapListMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataHeatmapList>>,
    TError,
    { data: BodyType<HeatmapListV7Request[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataHeatmapList>>,
  TError,
  { data: BodyType<HeatmapListV7Request[]> },
  TContext
> => {
  const mutationKey = ['postV7DataHeatmapList'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataHeatmapList>>,
    { data: BodyType<HeatmapListV7Request[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataHeatmapList(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataHeatmapListMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataHeatmapList>>
>;
export type PostV7DataHeatmapListMutationBody = BodyType<HeatmapListV7Request[]>;
export type PostV7DataHeatmapListMutationError = ErrorType<unknown>;

/**
 * @summary heatmap-list response
 */
export const usePostV7DataHeatmapList = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataHeatmapList>>,
      TError,
      { data: BodyType<HeatmapListV7Request[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataHeatmapList>>,
  TError,
  { data: BodyType<HeatmapListV7Request[]> },
  TContext
> => {
  const mutationOptions = getPostV7DataHeatmapListMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary target, table의 컬럼 정보
 */
export const postV7DataMetaTargetColumn = (
  metaStatV7Request: MaybeRef<MetaStatV7Request[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  metaStatV7Request = unref(metaStatV7Request);

  return customAxiosInstance<DataMetaStatResponse>(
    {
      url: `/api/v7/data/meta-target-column`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: metaStatV7Request,
      signal,
    },
    options,
  );
};

export const getPostV7DataMetaTargetColumnMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataMetaTargetColumn>>,
    TError,
    { data: BodyType<MetaStatV7Request[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataMetaTargetColumn>>,
  TError,
  { data: BodyType<MetaStatV7Request[]> },
  TContext
> => {
  const mutationKey = ['postV7DataMetaTargetColumn'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataMetaTargetColumn>>,
    { data: BodyType<MetaStatV7Request[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataMetaTargetColumn(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataMetaTargetColumnMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataMetaTargetColumn>>
>;
export type PostV7DataMetaTargetColumnMutationBody = BodyType<MetaStatV7Request[]>;
export type PostV7DataMetaTargetColumnMutationError = ErrorType<unknown>;

/**
 * @summary target, table의 컬럼 정보
 */
export const usePostV7DataMetaTargetColumn = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataMetaTargetColumn>>,
      TError,
      { data: BodyType<MetaStatV7Request[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataMetaTargetColumn>>,
  TError,
  { data: BodyType<MetaStatV7Request[]> },
  TContext
> => {
  const mutationOptions = getPostV7DataMetaTargetColumnMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Metric Response
 */
export const postV7DataMetrics = (
  metricV7RequestArrayBody: MaybeRef<MetricV7RequestArrayBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  metricV7RequestArrayBody = unref(metricV7RequestArrayBody);

  return customAxiosInstance<DataMetricResponse>(
    {
      url: `/api/v7/data/metrics`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: metricV7RequestArrayBody,
      signal,
    },
    options,
  );
};

export const getPostV7DataMetricsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataMetrics>>,
    TError,
    { data: BodyType<MetricV7RequestArrayBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataMetrics>>,
  TError,
  { data: BodyType<MetricV7RequestArrayBody> },
  TContext
> => {
  const mutationKey = ['postV7DataMetrics'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataMetrics>>,
    { data: BodyType<MetricV7RequestArrayBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataMetrics(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataMetricsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataMetrics>>
>;
export type PostV7DataMetricsMutationBody = BodyType<MetricV7RequestArrayBody>;
export type PostV7DataMetricsMutationError = ErrorType<unknown>;

/**
 * @summary Metric Response
 */
export const usePostV7DataMetrics = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataMetrics>>,
      TError,
      { data: BodyType<MetricV7RequestArrayBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataMetrics>>,
  TError,
  { data: BodyType<MetricV7RequestArrayBody> },
  TContext
> => {
  const mutationOptions = getPostV7DataMetricsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Metric List Response
 */
export const postV7DataMetricsList = (
  metricV7RequestArrayBody: MaybeRef<MetricV7RequestArrayBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  metricV7RequestArrayBody = unref(metricV7RequestArrayBody);

  return customAxiosInstance<DataTableResponse>(
    {
      url: `/api/v7/data/metrics-list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: metricV7RequestArrayBody,
      signal,
    },
    options,
  );
};

export const getPostV7DataMetricsListMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataMetricsList>>,
    TError,
    { data: BodyType<MetricV7RequestArrayBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataMetricsList>>,
  TError,
  { data: BodyType<MetricV7RequestArrayBody> },
  TContext
> => {
  const mutationKey = ['postV7DataMetricsList'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataMetricsList>>,
    { data: BodyType<MetricV7RequestArrayBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataMetricsList(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataMetricsListMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataMetricsList>>
>;
export type PostV7DataMetricsListMutationBody = BodyType<MetricV7RequestArrayBody>;
export type PostV7DataMetricsListMutationError = ErrorType<unknown>;

/**
 * @summary Metric List Response
 */
export const usePostV7DataMetricsList = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataMetricsList>>,
      TError,
      { data: BodyType<MetricV7RequestArrayBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataMetricsList>>,
  TError,
  { data: BodyType<MetricV7RequestArrayBody> },
  TContext
> => {
  const mutationOptions = getPostV7DataMetricsListMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Metric Batch Response - 병렬 처리
 */
export const postV7DataMetricsBatch = (
  metricV7RequestArrayBody: MaybeRef<MetricV7RequestArrayBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  metricV7RequestArrayBody = unref(metricV7RequestArrayBody);

  return customAxiosInstance<DataMetricResponse>(
    {
      url: `/api/v7/data/metrics/batch`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: metricV7RequestArrayBody,
      signal,
    },
    options,
  );
};

export const getPostV7DataMetricsBatchMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataMetricsBatch>>,
    TError,
    { data: BodyType<MetricV7RequestArrayBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataMetricsBatch>>,
  TError,
  { data: BodyType<MetricV7RequestArrayBody> },
  TContext
> => {
  const mutationKey = ['postV7DataMetricsBatch'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataMetricsBatch>>,
    { data: BodyType<MetricV7RequestArrayBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataMetricsBatch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataMetricsBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataMetricsBatch>>
>;
export type PostV7DataMetricsBatchMutationBody = BodyType<MetricV7RequestArrayBody>;
export type PostV7DataMetricsBatchMutationError = ErrorType<unknown>;

/**
 * @summary Metric Batch Response - 병렬 처리
 */
export const usePostV7DataMetricsBatch = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataMetricsBatch>>,
      TError,
      { data: BodyType<MetricV7RequestArrayBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataMetricsBatch>>,
  TError,
  { data: BodyType<MetricV7RequestArrayBody> },
  TContext
> => {
  const mutationOptions = getPostV7DataMetricsBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Scatter Response
 */
export const postV7DataScatter = (
  scatterV7Request: MaybeRef<ScatterV7Request[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  scatterV7Request = unref(scatterV7Request);

  return customAxiosInstance<DataScatterResponse>(
    {
      url: `/api/v7/data/scatter`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: scatterV7Request,
      signal,
    },
    options,
  );
};

export const getPostV7DataScatterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataScatter>>,
    TError,
    { data: BodyType<ScatterV7Request[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataScatter>>,
  TError,
  { data: BodyType<ScatterV7Request[]> },
  TContext
> => {
  const mutationKey = ['postV7DataScatter'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataScatter>>,
    { data: BodyType<ScatterV7Request[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataScatter(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataScatterMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataScatter>>
>;
export type PostV7DataScatterMutationBody = BodyType<ScatterV7Request[]>;
export type PostV7DataScatterMutationError = ErrorType<unknown>;

/**
 * @summary Scatter Response
 */
export const usePostV7DataScatter = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataScatter>>,
      TError,
      { data: BodyType<ScatterV7Request[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataScatter>>,
  TError,
  { data: BodyType<ScatterV7Request[]> },
  TContext
> => {
  const mutationOptions = getPostV7DataScatterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary scatter 연계용
 */
export const postV7DataScatterDetail = (
  scatterDetailRequestArrayBody: MaybeRef<ScatterDetailRequestArrayBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  scatterDetailRequestArrayBody = unref(scatterDetailRequestArrayBody);

  return customAxiosInstance<DataScatterDetailResponse>(
    {
      url: `/api/v7/data/scatter-detail`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: scatterDetailRequestArrayBody,
      signal,
    },
    options,
  );
};

export const getPostV7DataScatterDetailMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataScatterDetail>>,
    TError,
    { data: BodyType<ScatterDetailRequestArrayBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataScatterDetail>>,
  TError,
  { data: BodyType<ScatterDetailRequestArrayBody> },
  TContext
> => {
  const mutationKey = ['postV7DataScatterDetail'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataScatterDetail>>,
    { data: BodyType<ScatterDetailRequestArrayBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataScatterDetail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataScatterDetailMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataScatterDetail>>
>;
export type PostV7DataScatterDetailMutationBody = BodyType<ScatterDetailRequestArrayBody>;
export type PostV7DataScatterDetailMutationError = ErrorType<unknown>;

/**
 * @summary scatter 연계용
 */
export const usePostV7DataScatterDetail = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataScatterDetail>>,
      TError,
      { data: BodyType<ScatterDetailRequestArrayBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataScatterDetail>>,
  TError,
  { data: BodyType<ScatterDetailRequestArrayBody> },
  TContext
> => {
  const mutationOptions = getPostV7DataScatterDetailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary scatter 연계용
 */
export const postV7DataScatterList = (
  scatterDetailRequestArrayBody: MaybeRef<ScatterDetailRequestArrayBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  scatterDetailRequestArrayBody = unref(scatterDetailRequestArrayBody);

  return customAxiosInstance<DataScatterTableResponse>(
    {
      url: `/api/v7/data/scatter-list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: scatterDetailRequestArrayBody,
      signal,
    },
    options,
  );
};

export const getPostV7DataScatterListMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataScatterList>>,
    TError,
    { data: BodyType<ScatterDetailRequestArrayBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataScatterList>>,
  TError,
  { data: BodyType<ScatterDetailRequestArrayBody> },
  TContext
> => {
  const mutationKey = ['postV7DataScatterList'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataScatterList>>,
    { data: BodyType<ScatterDetailRequestArrayBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataScatterList(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataScatterListMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataScatterList>>
>;
export type PostV7DataScatterListMutationBody = BodyType<ScatterDetailRequestArrayBody>;
export type PostV7DataScatterListMutationError = ErrorType<unknown>;

/**
 * @summary scatter 연계용
 */
export const usePostV7DataScatterList = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataScatterList>>,
      TError,
      { data: BodyType<ScatterDetailRequestArrayBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataScatterList>>,
  TError,
  { data: BodyType<ScatterDetailRequestArrayBody> },
  TContext
> => {
  const mutationOptions = getPostV7DataScatterListMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Service Metric Response
 */
export const postV7DataServiceMetrics = (
  databaseServiceMetricV7Request: MaybeRef<DatabaseServiceMetricV7Request[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  databaseServiceMetricV7Request = unref(databaseServiceMetricV7Request);

  return customAxiosInstance<ServiceDataMetricResponse>(
    {
      url: `/api/v7/data/service-metrics`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: databaseServiceMetricV7Request,
      signal,
    },
    options,
  );
};

export const getPostV7DataServiceMetricsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataServiceMetrics>>,
    TError,
    { data: BodyType<DatabaseServiceMetricV7Request[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataServiceMetrics>>,
  TError,
  { data: BodyType<DatabaseServiceMetricV7Request[]> },
  TContext
> => {
  const mutationKey = ['postV7DataServiceMetrics'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataServiceMetrics>>,
    { data: BodyType<DatabaseServiceMetricV7Request[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataServiceMetrics(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataServiceMetricsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataServiceMetrics>>
>;
export type PostV7DataServiceMetricsMutationBody = BodyType<DatabaseServiceMetricV7Request[]>;
export type PostV7DataServiceMetricsMutationError = ErrorType<unknown>;

/**
 * @summary Service Metric Response
 */
export const usePostV7DataServiceMetrics = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataServiceMetrics>>,
      TError,
      { data: BodyType<DatabaseServiceMetricV7Request[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataServiceMetrics>>,
  TError,
  { data: BodyType<DatabaseServiceMetricV7Request[]> },
  TContext
> => {
  const mutationOptions = getPostV7DataServiceMetricsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Table Response
 */
export const postV7DataTable = (
  tableV7Request: MaybeRef<TableV7Request[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  tableV7Request = unref(tableV7Request);

  return customAxiosInstance<DataTableResponse>(
    {
      url: `/api/v7/data/table`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tableV7Request,
      signal,
    },
    options,
  );
};

export const getPostV7DataTableMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataTable>>,
    TError,
    { data: BodyType<TableV7Request[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataTable>>,
  TError,
  { data: BodyType<TableV7Request[]> },
  TContext
> => {
  const mutationKey = ['postV7DataTable'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataTable>>,
    { data: BodyType<TableV7Request[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataTable(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataTableMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataTable>>
>;
export type PostV7DataTableMutationBody = BodyType<TableV7Request[]>;
export type PostV7DataTableMutationError = ErrorType<unknown>;

/**
 * @summary Table Response
 */
export const usePostV7DataTable = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataTable>>,
      TError,
      { data: BodyType<TableV7Request[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataTable>>,
  TError,
  { data: BodyType<TableV7Request[]> },
  TContext
> => {
  const mutationOptions = getPostV7DataTableMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Tolpology Response
 */
export const postV7DataTopology = (
  topologyV7Request: MaybeRef<TopologyV7Request[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  topologyV7Request = unref(topologyV7Request);

  return customAxiosInstance<DataTopologyResponse>(
    {
      url: `/api/v7/data/topology`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: topologyV7Request,
      signal,
    },
    options,
  );
};

export const getPostV7DataTopologyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DataTopology>>,
    TError,
    { data: BodyType<TopologyV7Request[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DataTopology>>,
  TError,
  { data: BodyType<TopologyV7Request[]> },
  TContext
> => {
  const mutationKey = ['postV7DataTopology'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DataTopology>>,
    { data: BodyType<TopologyV7Request[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7DataTopology(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DataTopologyMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DataTopology>>
>;
export type PostV7DataTopologyMutationBody = BodyType<TopologyV7Request[]>;
export type PostV7DataTopologyMutationError = ErrorType<unknown>;

/**
 * @summary Tolpology Response
 */
export const usePostV7DataTopology = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DataTopology>>,
      TError,
      { data: BodyType<TopologyV7Request[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DataTopology>>,
  TError,
  { data: BodyType<TopologyV7Request[]> },
  TContext
> => {
  const mutationOptions = getPostV7DataTopologyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
